<template>
  <div id="container">
    <v-dialog v-model="enable" max-width="300" persistent>
      <v-card style="text-align:center">
        <div class="py-2">
            <div class="backcolor__icon">
              <v-icon class="icon"  color="success">done</v-icon>

            </div>
          </div>
       <v-card-title
          class="center_btns"
          style="font-weight:700; font-size:17px"
          primary-title
        >
          {{ description }}
        </v-card-title>
                 
        
      </v-card>
    </v-dialog>
  </div>
</template>

<script>


export default {
  props: ['value', 'description'],
  components:{
   

  },
  data() {
    return {
         enable: this.value,
    }
  },
  watch: {
    value() {
      this.enable = this.value
    },
  },
  methods: {
  
  },
  computed:{
    
  }
}
</script>

<style scoped>


.center_btns {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.backcolor__icon{
  background-color: #D1FAE5;
  display: flex;
  align-items: center;
  justify-content: center;
   border-radius: 50%;
   width: 50px;
   height: 50px;
  margin: auto;
}
.icon{
   font-size: 30px;
   border: none;

}
</style>
